import {
  ProposalNode,
  proposalNodeLabel,
} from '@/ui/pages/proposalBuilderPage/util';
import { Badge, Text } from '@payaca/ambrosia';
import CurrencyValue from '@payaca/components/currencyValue/CurrencyValue';
import { SortableTreeDragPreview } from '@payaca/dnd';
import { FC } from 'react';

const countItems = (nodes: ProposalNode[]): number =>
  nodes.reduce(
    (count, node) =>
      count + (node.type === 'item' ? 1 : countItems(node.children)),
    0
  );

const SELECTION_MODE_LABELS = {
  MULTI_CHOICE: 'Multi-select',
  OPTIONAL: 'Optional',
} as const;

const ProposalTreeDragPreview: FC<{ node: ProposalNode }> = (props) => {
  const { node } = props;

  if (node.type === 'item') {
    return (
      <SortableTreeDragPreview>
        <span className="truncate">
          <Text as="span">{proposalNodeLabel(node)}</Text>
        </span>
        <span className="shrink-0">
          <Text as="span">
            <CurrencyValue {...node.proposalLineItem.totals.totalValue} />
          </Text>
        </span>
      </SortableTreeDragPreview>
    );
  }

  const itemCount = countItems(node.children);
  const selectionModeLabel =
    node.selectionMode === 'MULTI_CHOICE' || node.selectionMode === 'OPTIONAL'
      ? SELECTION_MODE_LABELS[node.selectionMode]
      : null;

  return (
    <SortableTreeDragPreview>
      <span className="truncate">
        <Text as="span">{proposalNodeLabel(node)}</Text>
      </span>
      {selectionModeLabel && (
        <Badge size="sm" variant="soft">
          {selectionModeLabel}
        </Badge>
      )}
      {itemCount > 0 && (
        <span className="shrink-0">
          <Text as="span" level="supporting">
            {itemCount === 1 ? '1 item' : `${itemCount} items`}
          </Text>
        </span>
      )}
    </SortableTreeDragPreview>
  );
};

export default ProposalTreeDragPreview;
